/**
 * abilityVfxCrystalArrow — Ashe R Enchanted Crystal Arrow ice missile (SP-04).
 */
export function buildCrystalArrow(THREE, spec) {
  const group = new THREE.Group();
  const k = (spec.scale || 1.85) / 1.85;
  const ice = mat(THREE, spec.color || 0x67e8f9, 0.95);
  const crystal = mat(THREE, 0xecfeff, 0.98);
  addShaftAndTip(THREE, group, k, ice, crystal);
  addFinsGlowTrail(THREE, group, k, crystal, spec.color || 0x67e8f9);
  group.userData = { shape: 'crystal_arrow' };
  return group;
}

function addShaftAndTip(THREE, group, k, ice, crystal) {
  group.add(new THREE.Mesh(
    new THREE.CylinderGeometry(0.16 * k, 0.2 * k, 3.4 * k, 10).rotateX(Math.PI / 2),
    ice
  ));
  const tip = new THREE.Mesh(
    new THREE.ConeGeometry(0.42 * k, 1.1 * k, 8).rotateX(Math.PI / 2),
    crystal
  );
  tip.position.z = 1.7 * k;
  group.add(tip);
}

function addFinsGlowTrail(THREE, group, k, crystal, color) {
  for (let i = 0; i < 2; i += 1) {
    const fin = new THREE.Mesh(
      new THREE.BoxGeometry(0.12 * k, 0.04 * k, 0.7 * k),
      crystal
    );
    fin.position.set((i === 0 ? -1 : 1) * 0.28 * k, 0, -1.1 * k);
    group.add(fin);
  }
  group.add(new THREE.Mesh(new THREE.SphereGeometry(0.85 * k, 10, 10), mat(THREE, 0x38bdf8, 0.35)));
  const trail = new THREE.Mesh(new THREE.SphereGeometry(0.28 * k, 8, 8), mat(THREE, color, 0.45));
  trail.position.z = -1.55 * k;
  group.add(trail);
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
